module.exports = __webpack_public_path__ + "static/media/01.c6fcfffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/australia-two/01.jpg
// module id = 394
// module chunks = 0